$(document).ready(function() {
    $.validator.setDefaults({
        highlight: function (element) {
            $(element).addClass('is-invalid').removeClass('is-valid');
        },
        unhighlight: function (element) {
            $(element).removeClass('is-invalid').addClass('is-valid');
        },
        errorElement: 'span',
        errorClass: 'help-block',
        errorPlacement: function (error, element) {
            //
        }
    });
    var submitter;
    $("button").click(function () {
        submitter = $(this).attr("id");
    });

    $('#dag, #maand, #jaar, #voorwaarden').change(function(e) {
        // check if the select boxes dag maand jaar are a valid date
        var dag = $('#dag').val();
        var maand = $('#maand').val() - 1;
        var jaar = $('#jaar').val();
        var date = new Date(jaar, maand, dag);
        if (date.getDate() == dag && date.getMonth() == maand && date.getFullYear() == jaar) {
            // check if date dag maand jaar is 24 or older
            var today = new Date();
            var age = today.getFullYear() - jaar;
            if (today.getMonth() < maand || (today.getMonth() == maand && today.getDate() < dag)) {
                age--;
            }
            if (age >= 24) {
                console.log('24+');
                $('#error-leeftijd').addClass('d-none');
                $('#error-leeftijd2').addClass('d-none');
            } else {
                console.log('24-');
                $('#error-leeftijd').removeClass('d-none');
                $('#error-leeftijd2').removeClass('d-none');
                $('#voorwaarden').prop('checked', false);
            }

        } else {
            $('#error-leeftijd').addClass('d-none');
        }
    });


    $('.needs-validation input[type=text],.needs-validation input[type=email]').keyup(function(e) {
        if ($(this).val().length > 0)
            $(this).parent().find('label').addClass('active');
        else
            $(this).parent().find('label').removeClass('active');

    });

    $('.needs-validation input[type=text],.needs-validation input[type=email]').each(function(e) {
        if ($(this).val().length > 0)
            $(this).parent().find('label').addClass('active');
        else
            $(this).parent().find('label').removeClass('active');

    });

    $('.needs-validation select').change(function(e) {
        if ($(this).val().length > 0)
            $(this).parent().find('label').addClass('active');
        else
            $(this).parent().find('label').removeClass('active');
    });

    $('.needs-validation select').each(function(e) {
        if (($(this).val() != null) && ($(this).val().length > 0))
            $(this).parent().find('label').addClass('active');
        else
            $(this).parent().find('label').removeClass('active');
    });

    $('.needs-validation input').focus(function(e) {
        $('#succes-input').addClass('d-none');

    });
    $(".needs-validation").each(function(e) {
        $(this).validate({
            invalidHandler: function (event, validator) {
                // 'this' refers to the form
                if (validator.numberOfInvalids()) {
                    $('.error-input').removeClass('d-none');
                } else {
                    $('.error-input').addClass('d-none');
                }
            },
            submitHandler: function (form) {
                $('.error-input', form).addClass('d-none');
                $('.error-data', form).addClass('d-none');
                $('.succes-input', form).addClass('d-none');
                $.post(window.base_url + "engine/submit-data.php", $(form).serializeArray(), function (data) {
                    if (data.success) {
                        $('.succes-input', form).removeClass('d-none');
                        if (submitter == 'inschrijven') {
                            form.reset();
                        }
                        if (submitter == 'uitschrijven') {
                            $('#uitschrijven').addClass('d-none');
                            $('#update').addClass('d-none');
                            window.location.href  = window.location.href.replace('=afmelden', '=uitgeschreven');
                        }
                    } else {
                        $('.error-data', form).removeClass('d-none');
                    }
                }, 'json');

            }

        });
    });
});
